/*
 * Project: BookingEngine
 * Module: components/booking/rooms/RoomBoardTab.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';

import CloseIcon from '../../icons/CloseIcon';
import OpenEyeIcon from '../../icons/OpenEyeIcon';
import DsList from '../../ds/atoms/list';

import { getLangValue } from '../../../utils/Generic';

const SPLIT_LINES_RE = /[\r\n]+/; // skips empty lines

// TODO camador 2020-04 Usar este componente también para tooltip de tarifa
// En RoomsBestValue ya está así, generalizar
class BoardTooltip extends React.Component {
  constructor(props) {
    super(props);

    // We don't want to show the "info" icon if the board has no description
    const descField = this.isBoardTooltip(props) ? 'boardDescription' : 'cancellation_txt';
    const baseText = getLangValue(props.board, props.lang, descField);
    const lines = baseText ? baseText.split(SPLIT_LINES_RE) : [];
    this.state = {
      hasTooltip: lines.length > 0,
      showTooltip: false,
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  toggleTooltip() {
    this.setState({ showTooltip: !this.state.showTooltip });
  }

  isBoardTooltip(props) {
    return props.type === 'board';
  }

  /* eslint-disable react/no-danger */
  getBoardFormattedText(board) {
    const baseText = getLangValue(board, this.props.lang, 'boardDescription') || '';
    const lines = baseText.split(SPLIT_LINES_RE);
    if (lines.length > 5) {
      return <span dangerouslySetInnerHTML={{ __html: baseText }} />;
    }
    const items = lines.map((item) => ({ id: item, title: item }));
    return (
        <DsList items={items} className="text-extrabold" variant="check" iconClassName="text-green"/>
    );
  }
  /* eslint-enable react/no-danger */

  getRateFormattedText(rate, lang) {
    const baseText = getLangValue(rate, lang, 'cancellation_txt') || '';
    return baseText.replace(/\r\n/g, '<br/>');
  }

  getFormattedText(board, lang) {
    return this.isBoardTooltip(this.props)
      ? this.getBoardFormattedText(board, lang)
      : this.getRateFormattedText(board, lang);
  }

  renderTooltipTitle(board, lang) {
    if (!this.isBoardTooltip(this.props)) {
      return null;
    }
    return (
      <div className="text-primary uppercase text-left font-bold text-base mb-1">
        {getLangValue(board, lang, 'name')}
      </div>
    );
  }

  renderDescription(board, lang) {
    if (!this.state.hasTooltip) {
      return null;
    }
    return (
      <div className={`info-tooltip ${this.state.showTooltip ? 'info-tooltip--visible' : ''}`}
           onClick={this.toggleTooltip}>
        {this.renderTooltipTitle(board, lang)}
        <div className="info-tooltip__description">
          {this.getFormattedText(board)}
        </div>
        <CloseIcon />
      </div>
    );
  }

  render() {
    const {
      board, icon, lang, extraClass,
    } = this.props;
    return (
      <div className={`boardTooltip ${extraClass}`} onClick={this.toggleTooltip}>
        <span className="boardTooltip__name">
          {getLangValue(board, lang, 'name')}
        </span>
        {this.state.hasTooltip && (
        <div className="boardTooltip__icon">
          {icon === 'eye' ? <OpenEyeIcon /> : <i className="fa fa-info" />}
        </div>
        )}
        {this.renderDescription(board, lang)}
      </div>
    );
  }
}

BoardTooltip.propTypes = {
  board: PropTypes.object.isRequired,
  extraClass: PropTypes.string,
  lang: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['rate', 'board']),
  icon: PropTypes.oneOf(['info', 'eye']),
};

BoardTooltip.defaultProps = {
  type: 'board',
  icon: 'info',
  extraClass: '',
};

export default BoardTooltip;
